import React, { Component, Fragment } from 'react';
import { Button, Col, Row } from 'reactstrap';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import ReactLoading from 'react-loading';

import { isProd } from '../../../utilities/UrlPaths';
import { errorLoadingCatalogText } from '../../../utilities/StaticText';
import InlineAlert from '../../../utilities/form-components/InlineAlert';
import getPackageID from '../diy-services/getPackageId';
import RealizedPricesDropzone from './RealizedPricesDropzone';

// This represents the un-uploaded state of RealizedPrices
class RealizedPricesPreUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
      hasUploadErrors: false,
      loading: true,
      selectedRadio: 'realized'
    };
  }

  async componentDidMount() {
    const {
      match: {
        params: { catalogID }
      }
    } = this.props;

    const packageID = await getPackageID(catalogID);

    if (packageID) {
      this.setState({ packageID, loading: false });
    } else {
      this.setState({ loading: false, error: true });
    }
  }

  downloadSnapshot = () => {
    const {
      match: {
        params: { catalogID }
      }
    } = this.props;

    window.location.href = `/cps/app/catalog/${catalogID}/snapshot/realized`;
  };

  handleRadioChange = e => {
    this.setState({
      selectedRadio: e.target.id
    });
  };

  setUploadErrors = hasUploadErrors => {
    this.setState({ hasUploadErrors });
  };

  render() {
    const { error, loading } = this.state;

    if (loading) {
      return <ReactLoading className="loading-spinner" type="spin" color="black" />;
    }

    if (error) {
      return <InlineAlert baseText={errorLoadingCatalogText} />;
    }

    const {
      handleUpload,
      match: {
        params: { catalogID }
      }
    } = this.props;
    const { hasUploadErrors, packageID, selectedRadio } = this.state;

    return (
      <div className="mt-4">
        <Row>
          {/* Start Column */}
          <Col xs={12}>
            <Fragment>
              <h3>Step 1: Download CSV</h3>
              <p>
                <Button color="link" role="link" onClick={() => this.downloadSnapshot()}>
                  Download the CSV&nbsp;
                </Button>
                containing all current realized prices for the selected sale.
              </p>
            </Fragment>

            <h3>Step 2: Enter Realized Price, Save &amp; Upload Spreadsheet</h3>
            <p>
              In the CSV update the realized price column to represent the
              price you would like to display on site.
            </p>

            <p>
              Please Note: zero in the realized price column means
              unsold and will display as &quot;Passed&quot; on site.
            </p>

            <RealizedPricesDropzone
              acceptedFileList=".csv,.xls,.xlsx"
              catalogID={catalogID}
              handleUpload={handleUpload}
              setUploadErrors={this.setUploadErrors}
              multiple={false}
              packageID={packageID}
              selectedRadio={selectedRadio}
            />
          </Col>
        </Row>

        {!hasUploadErrors && (
          <div className="mt-4">
            <Link to="/my-auctions/sales">Cancel</Link>
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(RealizedPricesPreUpload);
